import React from 'react';
import Container from 'react-bootstrap/Container';

import './wrapper.scss';

export const Wrapper = ({ children }) => (
  <Container fluid className="wrapper">
    {children}
  </Container>
);
